import { render, staticRenderFns } from "./WangEditorControl.vue?vue&type=template&id=d6b530fc&scoped=true&"
import script from "./WangEditorControl.vue?vue&type=script&lang=js&"
export * from "./WangEditorControl.vue?vue&type=script&lang=js&"
import style0 from "./WangEditorControl.vue?vue&type=style&index=0&id=d6b530fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b530fc",
  null
  
)

export default component.exports